// 打刻を追加するときの日付の初期値。表示中の月が今月なら今日、それ以外はその月の1日。
export function defaultEditDate(monthDate) {
  const today = new Date();
  const y = monthDate.getFullYear();
  const m = monthDate.getMonth();
  const d = (y === today.getFullYear() && m === today.getMonth()) ? today.getDate() : 1;
  return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
}
